export default __webpack_public_path__ + "static/media/ic_infinitysign.17dd97d6.svg";